import {
	Container,
	Grid,
	Hidden,
	Paper,
	Theme,
	Typography,
	WithWidth,
	useMediaQuery,
	withStyles,
	withWidth,
} from '@material-ui/core';
import {WithStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import {IAnchorable} from 'src/Routes/Pages/IAnchorable';

import {interactionsBlockStyles} from './interactionsBlockStyles';

const InteractionsBlock = (props: IInteractionsBlockProps) => (
	<section className={props.classes.root} id={props.anchor}>
		<Container
			className={props.classes.container}
			maxWidth="lg"
			disableGutters={useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))}
		>
			<Grid container spacing={0}>
				<Grid item xs={12}>
					<Typography variant="h3" className={props.classes.title}>
						{props.t('title')}
					</Typography>
				</Grid>
				<Grid item lg={5} md={6} sm={7} xs={12}>
					<Typography variant="body2" className={props.classes.description}>
						{props.t('description')}
					</Typography>
					<div className={props.classes.insideBlockWrapper}>
						<Typography variant="h5" className={props.classes.insideSubTitle}>
							{props.t('inside-title')}
						</Typography>
						<Typography variant="body2" className={props.classes.insideDescription}>
							{props.t('inside-paragraph-1')}
						</Typography>
						<Typography variant="body2" className={props.classes.insideDescription}>
							{props.t('inside-paragraph-2')}
						</Typography>
					</div>
				</Grid>
				<Hidden smDown>
					<Grid item xs={3} md={2} lg={3}>
						<Typography variant="h5" className={props.classes.orBlock}>
							{props.t('or')}
						</Typography>
					</Grid>
				</Hidden>
				<Hidden smUp>
					<Grid item xs={12}>
						<Typography variant="h5" className={props.classes.orBlock}>
							{props.t('or')}
						</Typography>
					</Grid>
				</Hidden>
				<Grid item lg={4} md={4} sm={5} xs={12}>
					<Typography variant="h5" className={props.classes.outsideSubTitle}>
						{props.t('outside-title')}
					</Typography>
					<Paper elevation={24} className={props.classes.outsideText}>
						<Typography variant="body2" className={props.classes.outsideDescription}>
							{props.t('outside-paragraph-1')}
						</Typography>
						<Typography variant="body2" className={props.classes.outsideDescription}>
							{props.t('outside-paragraph-2')}
						</Typography>
					</Paper>
				</Grid>
			</Grid>
		</Container>
	</section>
);

interface IInteractionsBlockProps extends IAnchorable, WithTranslation, WithStyles, WithWidth {}

export default withStyles(interactionsBlockStyles)(withTranslation('interactions')(withWidth()(InteractionsBlock)));
